import { FormGroup } from '@angular/forms';

/**
   * Marks all controls in a form group as touched
   * @param formGroup - The group to caress..hah
   */
export const markFormGroupTouched = (formGroup: FormGroup) => {
  (<any>Object).values(formGroup.controls).forEach(control => {
    control.markAsTouched();

    if (control.controls) {
      this.markFormGroupTouched(control);
    }
  });
};

export const findFirstInvalidControlName = (formGroup: FormGroup) => {
  const controls = formGroup.controls;
  for (const name in controls) {
    if (controls[name].invalid) {
      return name;
    }
  }
  return '';
};

/**
* Format currency
*/
export const currencyFormatter = (value: number = 99, locale: string = 'en-US', currency: string = 'USD', decimalDigits: number = 0) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: decimalDigits,
    // the default value for minimumFractionDigits depends on the currency
    // and is usually already 2
  });

  return formatter.format(value);
};

export function  flattenObject(ob) {
  const toReturn = {};

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) {
      continue;
    }

    if ((typeof ob[i]) === 'object') {
      const flatObject = flattenObject(ob[i]);
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue;
        }

        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }

  return toReturn;
}

export const detectDevices = () => {
  return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
};



// WEBPACK FOOTER //
// ./src/app/core/utils.ts